import "babel-polyfill";
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './assets/iconfont.css'
import 'element-ui/lib/theme-chalk/display.css'
import global_ from './global'
String.prototype.replaceAll = function(s1, s2) {
    return this.replace(new RegExp(s1, "gm"), s2);
}
const api_for_vue = global_.api_user;
const router_xmgl = {
  xmgl_cjedit: { url: '/xmgl/cjedit', active: '/xmgl/cjedit' },
  xmgl_cjinfo: { url: '/xmgl/cjedit', active: '/xmgl/cjedit' },
  xmgl_cjeditsingle: { url: '/xmgl/cjedit', active: '/xmgl/cjedit' },
  xmgl_cjcode: { url: '/xmgl/cjcode', active: '/xmgl/cjcode' },
  xmgl_cjadd: { url: '/xmgl/cjedit', active: '/xmgl/cjadd' },
  xmgl_dep: { url: '/xmgl/dep', active: '/xmgl/dep' },
  xmgl_access: { url: '/xmgl/access', active: '/xmgl/access' },
  xmgl_message: { url: '/xmgl/message', active: '/xmgl/message' },
}
Vue.config.productionTip = false
Vue.use(VueAxios, axios)


router.beforeEach(({
  path
}, from, next) => {
  if (path === '/login') {
    next()
  }
  else if (path === '/reset') {
    next()
  }
  else if (path === '/resetFirst') {
    next()
  }
  else if (from.path === '/') {
    let _params = {
      servicename: "check_status",
    };
    Vue.axios
      .get(api_for_vue, {
        params: _params
      })
      .then(response => {
        let severLogin = response.data.resultinfo.if_login
        if (severLogin === false) {
          return next({
            path: '/login'
          })
        }
        else {
          store.state.user = response.data.resultinfo.user
          if (path.indexOf('/xmgl') > -1) {
            store.state.default_active = 'xmgl'
            store.state.xmgl_default_active = path
          }
          else if (path.indexOf('/xxcj') > -1) {
            store.state.default_active = 'xxcj'
          }
          store.commit("login");
          next()
        }
      })
  }
  else if (path === '/xmgl') {
    if (router_xmgl.hasOwnProperty(from.name)) {
      store.state.xmgl_default_active = router_xmgl[from.name].url
      next({
        path: router_xmgl[from.name].url
      })
    }
    else {
      let p = null
      switch (store.state.user.level) {
        case '地市':
          p = '/xmgl/cjedit'
          break
        case '区县':
          p = '/xmgl/dep'
          break
        default:
          p = null
      }
      store.state.xmgl_default_active = p
      next({
        path: p
      })
    }
  }
  else {
    next()
  }
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')